<template>
    <div class="text-xs-center">
        <v-dialog
        v-model="dialogdescription"
        width="500">
        
        <v-card>
            <v-card-title>
                <v-layout justify-center>
                <label class="headline grey lighten-2"> BIENVENIDO</label>
                </v-layout>
            </v-card-title>
            
            <v-card-text >
                {{datadescriptioncompany}}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                 <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="dialogdescription = false"
                >
                    ACEPTAR
                </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { EventBus } from './../../../helpers/eventbus/event-bus'
export default {
    data(){
        return{
            dialogdescription:false,
            datadescriptioncompany: ''
        }
    },
    mounted(){
        EventBus.$on('openmodaldescription',(description)=>{
            this.opendialogdescription()
            this.datadescriptioncompany = description
        })
    },
    methods: {
        opendialogdescription(){
            this.dialogdescription=true
        }

    },
}
</script>
